import React from 'react';
import PropTypes from 'prop-types';
import range from 'lodash/range';
import { connect } from 'react-redux';
import a from '../../../../../redux/actions';
import s from '../../../../../redux/selectors';
import { wrap, withT } from '../../../../../lib/wrappers';

import InlineInput from '../InlineInput';
import InlineSelect from '../InlineSelect';
import BlankLink from '../../../../common/BlankLink';

const percentOptions = range(0.1, 1.1, 0.1).map(value => ({
  value,
  display: `${Math.round(value * 100)}%`,
}));

const LineDryClothing = ({
  t,
  widgetSource,
  resultTakeactionLineDryClothingDryerkwhyr,
  resultTakeactionLineDryClothingDryercostyr,
}) => (
  <div className="action-details">
    <div className="action-details__form">
      <p>
        {t('My household dries')}
        <InlineInput
          maxLength={3}
          apiKey={'input_takeaction_line_dry_clothing_dryerldwk'}
        />
        {
          // eslint-disable-next-line no-template-curly-in-string
          t('loads of laundry per week using {{resultTakeactionLineDryClothingDryerkwhyr}} kWh of electricity per year, at a cost of ${{resultTakeactionLineDryClothingDryercostyr}} per year. I pledge to dry', {
            resultTakeactionLineDryClothingDryerkwhyr,
            resultTakeactionLineDryClothingDryercostyr,
          })
        }
        <InlineSelect
          apiKey="input_takeaction_line_dry_clothing_percentdry"
          options={percentOptions}
        />
        {t('of these loads on the line or on a rack.')}
      </p>
    </div>
    <div className="action-details__facts">
      <p>
        {t('If it\'s not sunny enough outdoors, consider drying indoors. On top of saving emissions and money, it\'s nicer for your clothes and helps extend their lifetime.')}
      </p>
      {widgetSource === 'ontario' &&
        <p>
          {t('Consider drying your clothes indoors on a portable rack in the winter. You save emissions and money, it\'s nicer for your clothes, reduces shrinkage and helps extend their lifetime.')}
        </p>
      }
    </div>
    <div className="action-details__links">
      {widgetSource !== 'ontario' &&
        <a
          href="http://www.coolcalifornia.org/funding-wizard#search//%255BZipcode%253D%253D94720%255D%255BEligible+Applicants%253D%253DIndividual%255D%255BCategory%253D%253DEnergy%255D/false/none/false/1/12"
          target="_blank"
          rel="noopener noreferrer"
        >{t('Find rebates and incentives for this action')}</a>
      }
      {widgetSource === 'ontario' &&
        <div>
          <p>
            {t('During Save on Energy DEAL DAYS you can save $8 off the purchase of an outdoor clothesline at a participating retailer. To learn more about this program, check out')}
            &nbsp;
            <BlankLink href={`https://${t('greenon.ca/')}`} text={t('the Green Ontario Fund Website')} />.
          </p>
        </div>
      }
    </div>
    <div className="action-details__assumptions">
      <div className="action-details__assumptions__header">{t('Assumptions')}</div>
      <ul>
        <li>
          {t('cost of electricity')}
          <InlineInput
            apiKey="input_takeaction_assumption_kwhprice"
            maxLength={3}
          />
          {t('cents per kWh')}
        </li>
        <li>
          {t('3.16 kWh per load')}
        </li>
      </ul>
    </div>
  </div>
);

LineDryClothing.propTypes = {
  // wrapped
  t: PropTypes.func.isRequired,
  // connected props
  widgetSource: PropTypes.string.isRequired,
  resultTakeactionLineDryClothingDryerkwhyr: PropTypes.string.isRequired,
  resultTakeactionLineDryClothingDryercostyr: PropTypes.string.isRequired,
};

const mapStateToProps = (state, ownProps) => [
  'resultTakeactionLineDryClothingDryerkwhyr',
  'resultTakeactionLineDryClothingDryercostyr',
].reduce((props, apiKey) => ({
  ...props,
  [apiKey]: s.results(apiKey)(state, ownProps),
}), {
  widgetSource: s.widgetSource(state),
});

const mapDispatchToProps = () => ({});

export default wrap(
  withT('lineDryClothing'),
  connect(mapStateToProps, mapDispatchToProps)(LineDryClothing),
);
